import eyeClosed from "../../assets/design-revamp/eye-closed.svg";

const HideTableIcon = ({ style }) => {
  return (
    <>
      <div>
        <img
          className=""
          src={eyeClosed}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default HideTableIcon;
